/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import testiLeft from "../assets/images/all-img/testi-left.svg";
import { useNavigate } from "react-router-dom";

const Testimonials = () => {

  const navigate = useNavigate();

  return (
    <div className=" section-padding bg-[url('../images/all-img/section-bg-16.png')] bg-cover  bg-no-repeat lg:mt-[136px]">
      <div className="container lg:-mt-[250px] xl:pb-[136px] lg:pb-20 pb-10">
        <div
          className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] bg-white shadow-box14 rounded-md
                divide-x-2 divide-[#E4EEED] py-20"
        >
          <div className=" text-center ">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">100</span>K+
            </h2>
            <span className="block text-black font-semibold">
              Enrolled Students
            </span>
          </div>

          <div className="  text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">100</span>+
            </h2>
            <span className="block text-black font-semibold">
              successful Professionals
            </span>
          </div>

          <div className=" text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">5</span>+
            </h2>
            <span className="block text-black font-semibold">
              Number of Courses
            </span>
          </div>

          <div className="  text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">37</span>+
            </h2>
            <span className="block text-black font-semibold">
              Total Number of Reviews
            </span>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="grid grid-cols-12 lg:gap-10 gap-6 ">
          <div className="xl:col-span-7 lg:col-span-6 col-span-12">
            <img src={testiLeft} alt="" draggable="false" />
          </div>
          <div className="xl:col-span-5 lg:col-span-6 col-span-12 flex flex-col justify-center ">
            <div className="mini-title">Testimonial</div>
            <h4 className="column-title ">
              Real Stories
              <span className="shape-bg">Real Success</span>
            </h4>
            <div>
              Discover how our programs have transformed careers through real
              success stories from our empowered and accomplished students.
            </div>
            {/* <div className="mt-12">
              <a onClick={()=>navigate('/testimonials')} className="btn btn-primary">
                View All Reviews
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
